import Axios from 'axios';

export const setAuthorizationHeader = (token: string) => {
	console.info('Access token has been set');
	// TODO: Toistettu sama toiminto kahdella tapaa
	// teoriassa default headerin asetus riittää mutta käytännössä
	// oli pakko asettaa localstoragen ja axios-interceptorin kautta
	localStorage.setItem('API_CLIENT_TOKEN', token);
	Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearAuthorizationHeader = () => {
	console.info('Access token has been cleared');
	Axios.defaults.headers.common['Authorization'] = '';
	localStorage.removeItem('API_CLIENT_TOKEN');
};
